/* ============================================================
   TC Collection v3 — tek veri kaynaklı filtre + grid modülü
   Dosya: assets/tc-collection.js

   İlke: grid de facet sayıları da AYNI veri setinden, AYNI
   matches() fonksiyonundan türer — matematiksel olarak çelişemez.
   - Stokta olmayan ürün veri setine hiç alınmaz (her yerde gizli).
   - Gruplar arası AND, grup içi OR (multi-select).
   - Beden/Renk varyant bazlı: seçilen değerde STOKTA varyant şartı.
   - Fiyat: hazır aralık checkbox'ları (kuruş/100 = TL, tr-TR format).
   - Her değişiklik ANINDA uygulanır; URL history.pushState ile senkron.
   - localStorage/sessionStorage YOK.
   ============================================================ */
(function () {
  'use strict';

  var CHUNK = 24;             // sonsuz kaydırma parça boyutu
  var NEW_SECONDS = 2592000;  // 30 gün

  /* ---------------- yardımcılar ---------------- */

  function toArr(v) {
    if (v === null || v === undefined || v === '') return [];
    if (Array.isArray(v)) return v.map(function (x) { return String(x); });
    return [String(v)];
  }

  function norm(s) {
    return String(s).trim().toLocaleLowerCase('tr-TR');
  }

  function money(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Nebim verisinde aynı beden hem "36,5" hem "36.5" olarak gelebiliyor —
     sayısal bedenlerde virgülü noktaya çevirip tek değerde birleştir. */
  function cleanSize(s) {
    s = String(s).trim();
    return /^\d+,\d+$/.test(s) ? s.replace(',', '.') : s;
  }

  /* ---------------- grup tanımları ---------------- */

  /* ÖNEMLİ: URL paramları "filter.*" ile BAŞLAYAMAZ — Shopify storefront,
     filter.* paramlarını sunucu tarafında collection.products'a uygular ve
     sayfaya gömülen veri seti ÖN-FİLTRELENMİŞ gelir (tek veri kaynağı bozulur).
     Bu yüzden Shopify'ın yok saydığı kendi "tc.*" alanımızı kullanıyoruz. */
  var GROUPS = [
    { key: 'vendor',      label: 'Marka',        param: 'tc.marka',       type: 'list',  get: function (p) { return toArr(p.vendor); } },
    { key: 'anakategori', label: 'Ana Kategori', param: 'tc.anakategori', type: 'list',  get: function (p) { return toArr(p.anakategori); } },
    { key: 'cinsiyet',    label: 'Cinsiyet',     param: 'tc.cinsiyet',    type: 'list',  get: function (p) { return toArr(p.cinsiyet); } },
    { key: 'kategori',    label: 'Kategori',     param: 'tc.kategori',    type: 'list',  get: function (p) { return toArr(p.kategori); } },
    { key: 'beden',       label: 'Beden',        param: 'tc.beden',       type: 'size',  variant: true, vget: function (v) { return toArr(v.beden).map(cleanSize); } },
    { key: 'renk',        label: 'Renk',         param: 'tc.renk',        type: 'color', variant: true, vget: function (v) { return toArr(v.renk); } },
    { key: 'price',       label: 'Fiyat',        param: 'tc.fiyat',       type: 'price' }
  ];

  var VARIANT_GROUPS = GROUPS.filter(function (g) { return g.variant; });

  /* Fiyat aralıkları — TL bazında; min hariç, max dahil. price kuruş → /100 */
  var PRICE_RANGES = [
    { id: '0-1000',    label: '1.000 TL ve altı',  min: -1,   max: 1000 },
    { id: '1000-2000', label: '1.000 – 2.000 TL',  min: 1000, max: 2000 },
    { id: '2000-3000', label: '2.000 – 3.000 TL',  min: 2000, max: 3000 },
    { id: '3000-5000', label: '3.000 – 5.000 TL',  min: 3000, max: 5000 },
    { id: '5000-',     label: '5.000 TL ve üzeri', min: 5000, max: Infinity }
  ];

  function rangeById(id) {
    for (var i = 0; i < PRICE_RANGES.length; i++) if (PRICE_RANGES[i].id === id) return PRICE_RANGES[i];
    return null;
  }

  var SIZE_ORDER = ['xxs', 'xs', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', 'xxl', '2xl', 'xxxl', '3xl', '4xl', '5xl'];

  var COLOR_MAP = {
    'siyah': '#111111', 'black': '#111111',
    'beyaz': '#ffffff', 'white': '#ffffff',
    'gri': '#9e9e9e', 'grey': '#9e9e9e', 'gray': '#9e9e9e',
    'antrasit': '#3a3f44', 'füme': '#4b4f54',
    'kırmızı': '#d32f2f', 'red': '#d32f2f',
    'bordo': '#7b1f2b', 'burgundy': '#7b1f2b', 'maroon': '#7b1f2b',
    'mavi': '#1565c0', 'blue': '#1565c0',
    'lacivert': '#0d2149', 'navy': '#0d2149',
    'turkuaz': '#26c6da', 'turquoise': '#26c6da', 'petrol': '#0f5e6b',
    'yeşil': '#2e7d32', 'green': '#2e7d32',
    'haki': '#6b6b47', 'khaki': '#6b6b47',
    'sarı': '#f6d32d', 'yellow': '#f6d32d',
    'turuncu': '#ef6c00', 'orange': '#ef6c00',
    'mor': '#6a1b9a', 'purple': '#6a1b9a', 'lila': '#b39ddb', 'lilac': '#b39ddb',
    'pembe': '#ec6aa0', 'pink': '#ec6aa0', 'fuşya': '#d81b8c', 'fuchsia': '#d81b8c',
    'kahverengi': '#6d4c41', 'brown': '#6d4c41',
    'bej': '#d9c7a7', 'beige': '#d9c7a7', 'krem': '#f1e7d3', 'cream': '#f1e7d3',
    'ekru': '#ede3ce', 'ecru': '#ede3ce', 'vizon': '#a89484', 'camel': '#b98a5a',
    'altın': '#c9a227', 'gold': '#c9a227', 'gümüş': '#c0c0c0', 'silver': '#c0c0c0',
    'mercan': '#ff6f61', 'coral': '#ff6f61', 'kiremit': '#b0453a',
    'mürdüm': '#5b2a4a', 'plum': '#5b2a4a', 'nude': '#e3c4a8', 'mint': '#98d8c8',
    'neon': '#ccff00', 'neon sarı': '#ccff00', 'neon yeşil': '#39ff14'
  };

  /* ---------------- durum ---------------- */

  var ALL = [];        // veri seti — yalnız stoktaki ürünler
  var seenIds = {};
  var meta = null;
  var state = { sel: {}, sort: 'manual' };   // sel[key] = { normVal: rawVal }
  var ui = { collapsed: {}, showAll: {}, search: {} };
  var visible = [];
  var renderedCount = 0;
  var facets = {};
  var pagesLoading = false; // arka plan veri sayfaları hâlâ yükleniyor mu

  var el = {}; // DOM referansları

  GROUPS.forEach(function (g) { state.sel[g.key] = {}; });

  function hasSel(key) {
    for (var k in state.sel[key]) return true;
    return false;
  }

  function selCount(key) {
    var n = 0;
    for (var k in state.sel[key]) n++;
    return n;
  }

  function totalSelCount() {
    var n = 0;
    GROUPS.forEach(function (g) { n += selCount(g.key); });
    return n;
  }

  /* ---------------- eşleşme mantığı (TEK doğruluk kaynağı) ---------------- */

  function productGroupOk(p, g) {
    var vals = g.get(p);
    for (var i = 0; i < vals.length; i++) {
      if (state.sel[g.key][norm(vals[i])]) return true;
    }
    return false;
  }

  function priceOk(p) {
    var tl = p.price / 100;
    for (var id in state.sel.price) {
      var r = rangeById(id);
      if (r && tl > r.min && tl <= r.max) return true;
    }
    return false;
  }

  /* Varyant, stokta olmalı ve (excludeKey hariç) seçili tüm varyant gruplarına uymalı */
  function variantOk(v, excludeKey) {
    if (!v.available) return false;
    for (var i = 0; i < VARIANT_GROUPS.length; i++) {
      var g = VARIANT_GROUPS[i];
      if (g.key === excludeKey || !hasSel(g.key)) continue;
      var vals = g.vget(v);
      var hit = false;
      for (var j = 0; j < vals.length; j++) {
        if (state.sel[g.key][norm(vals[j])]) { hit = true; break; }
      }
      if (!hit) return false;
    }
    return true;
  }

  /* Ürün, excludeKey grubu HARİÇ tüm aktif filtrelere uyuyor mu?
     Grid: matches(p, null). Facet sayıları: matches(p, grupKey). */
  function matches(p, excludeKey) {
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i];
      if (g.key === excludeKey || g.variant || !hasSel(g.key)) continue;
      if (g.type === 'price') {
        if (!priceOk(p)) return false;
      } else if (!productGroupOk(p, g)) {
        return false;
      }
    }
    var anyVariantSel = false;
    for (var k = 0; k < VARIANT_GROUPS.length; k++) {
      if (VARIANT_GROUPS[k].key !== excludeKey && hasSel(VARIANT_GROUPS[k].key)) { anyVariantSel = true; break; }
    }
    if (anyVariantSel) {
      var ok = false;
      for (var m = 0; m < p.variants.length; m++) {
        if (variantOk(p.variants[m], excludeKey)) { ok = true; break; }
      }
      if (!ok) return false;
    }
    return true;
  }

  /* ---------------- facet sayıları ---------------- */

  function computeFacets() {
    facets = {};
    GROUPS.forEach(function (g) {
      var base = ALL.filter(function (p) { return matches(p, g.key); });

      if (g.type === 'price') {
        facets.price = PRICE_RANGES.map(function (r) {
          return {
            id: r.id, label: r.label,
            count: base.filter(function (p) { var tl = p.price / 100; return tl > r.min && tl <= r.max; }).length
          };
        });
        return;
      }

      var map = {}; // norm -> { raw, count }
      base.forEach(function (p) {
        var seen = {};
        if (g.variant) {
          p.variants.forEach(function (v) {
            if (!variantOk(v, g.key)) return; // yalnız stokta + diğer varyant filtrelerine uyan varyantlar
            g.vget(v).forEach(function (val) {
              var n = norm(val);
              if (!n || seen[n]) return;
              seen[n] = true;
              if (!map[n]) map[n] = { raw: String(val).trim(), count: 0 };
              map[n].count++;
            });
          });
        } else {
          g.get(p).forEach(function (val) {
            var n = norm(val);
            if (!n || seen[n]) return;
            seen[n] = true;
            if (!map[n]) map[n] = { raw: String(val).trim(), count: 0 };
            map[n].count++;
          });
        }
      });
      facets[g.key] = map;
    });
  }

  /* ---------------- sıralama ---------------- */

  function sizeRank(s) {
    var n = norm(s);
    var idx = SIZE_ORDER.indexOf(n);
    if (idx > -1) return idx;
    var num = parseFloat(n.replace(',', '.'));
    if (!isNaN(num)) return 100 + num;
    return 10000;
  }

  function sortedValues(g) {
    if (g.type === 'price') return null;
    var map = facets[g.key] || {};
    var vals = [];
    for (var n in map) {
      vals.push({ norm: n, raw: map[n].raw, count: map[n].count, checked: !!state.sel[g.key][n] });
    }
    // Seçili ama (mevcut kombinasyonda) 0 sonuçlu değerler de listede kalsın — kaldırılabilsin
    for (var sn in state.sel[g.key]) {
      if (!map[sn]) vals.push({ norm: sn, raw: state.sel[g.key][sn], count: 0, checked: true });
    }
    if (g.type === 'size') {
      vals.sort(function (a, b) {
        var ra = sizeRank(a.raw), rb = sizeRank(b.raw);
        if (ra !== rb) return ra - rb;
        return a.raw.localeCompare(b.raw, 'tr');
      });
    } else {
      vals.sort(function (a, b) { return a.raw.localeCompare(b.raw, 'tr'); });
    }
    return vals;
  }

  function sortProducts(arr) {
    var a = arr.slice();
    switch (state.sort) {
      case 'price-ascending':   a.sort(function (x, y) { return x.price - y.price; }); break;
      case 'price-descending':  a.sort(function (x, y) { return y.price - x.price; }); break;
      case 'created-descending': a.sort(function (x, y) { return y.createdAt - x.createdAt; }); break;
      case 'created-ascending':  a.sort(function (x, y) { return x.createdAt - y.createdAt; }); break;
      case 'title-ascending':   a.sort(function (x, y) { return x.title.localeCompare(y.title, 'tr'); }); break;
      case 'title-descending':  a.sort(function (x, y) { return y.title.localeCompare(x.title, 'tr'); }); break;
      default:                  a.sort(function (x, y) { return x.idx - y.idx; });
    }
    return a;
  }

  /* ---------------- facet render ---------------- */

  var CHEVRON = '<svg class="tc-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="18 15 12 9 6 15"/></svg>';

  /* Varyant bazlı gruplarda (Beden/Renk) veri tamamlanana dek uyarı göster —
     eksik liste "bozuk" sanılmasın. */
  function loadingHintHTML() {
    return pagesLoading
      ? '<div class="tc-facet-loading"><span class="tc-spinner-sm"></span>Tüm seçenekler yükleniyor…</div>'
      : '';
  }

  function groupHeaderHTML(g, count) {
    var badge = count > 0 ? '<span class="tc-filter-count">' + count + '</span>' : '';
    return '<button class="tc-filter-group-header" type="button" data-action="toggle-group" aria-expanded="' + (ui.collapsed[g.key] ? 'false' : 'true') + '">' +
      '<span>' + esc(g.label) + '</span>' + badge + CHEVRON + '</button>';
  }

  function listGroupHTML(g, vals) {
    var searching = (ui.search[g.key] || '').length > 0;
    var searchNorm = norm(ui.search[g.key] || '');
    var showSearch = vals.length > 8;
    var html = '';

    html += '<div class="tc-filter-group' + (selCount(g.key) ? ' tc-has-active' : '') + '" data-group="' + g.key + '" data-filter-type="list">';
    html += groupHeaderHTML(g, selCount(g.key));
    html += '<div class="tc-filter-group-body' + (ui.collapsed[g.key] ? ' collapsed' : '') + '">';

    if (showSearch) {
      html += '<div class="tc-filter-search-wrapper"><input type="text" class="tc-filter-search-input" data-search="' + g.key + '" placeholder="' + esc(g.label) + ' ara..." value="' + esc(ui.search[g.key] || '') + '"></div>';
    }

    var hiddenCount = 0;
    html += '<ul class="tc-filter-list">';
    vals.forEach(function (v, i) {
      var liClass = '';
      if (searching) {
        if (norm(v.raw).indexOf(searchNorm) === -1) liClass = 'tc-filter-item-hidden';
      } else if (i >= 5 && !v.checked && !ui.showAll[g.key]) {
        liClass = 'tc-filter-item-hidden';
        hiddenCount++;
      }
      html += '<li' + (liClass ? ' class="' + liClass + '"' : '') + '>' +
        '<label class="tc-filter-label' + (v.checked ? ' tc-filter-active' : '') + '">' +
        '<div class="tc-checkbox-wrapper">' +
        '<input type="checkbox" class="tc-checkbox" data-group="' + g.key + '" value="' + esc(v.raw) + '"' + (v.checked ? ' checked' : '') + '>' +
        '<span class="tc-custom-checkbox"></span></div>' +
        '<span class="tc-label-text">' + esc(v.raw) + '</span>' +
        '<span class="tc-label-count">' + v.count + '</span>' +
        '</label></li>';
    });
    html += '</ul>';

    if (!searching && vals.length > 5) {
      html += '<button type="button" class="tc-show-more-btn" data-action="show-more">' +
        (ui.showAll[g.key] ? 'Daha Az Göster' : 'Tümünü Göster <span class="tc-show-more-count">(' + hiddenCount + ' daha)</span>') +
        '</button>';
    }

    html += '</div></div>';
    return html;
  }

  function sizeGroupHTML(g, vals) {
    // Varsayılanda EN ÇOK ürünü olan bedenler görünür (pozisyona göre değil) —
    // yoksa liste başındaki harf/pantolon bedenleri popüler ayakkabı numaralarını
    // "Tümünü Göster" arkasına gizliyordu. Görüntü sırası yine beden sırası.
    var CAP = 16;
    var top = {};
    vals.slice().sort(function (a, b) { return b.count - a.count; }).slice(0, CAP)
      .forEach(function (v) { top[v.norm] = 1; });
    var hiddenCount = 0;
    var html = '<div class="tc-filter-group' + (selCount(g.key) ? ' tc-has-active' : '') + '" data-group="' + g.key + '" data-filter-type="size">';
    html += groupHeaderHTML(g, selCount(g.key));
    html += '<div class="tc-filter-group-body' + (ui.collapsed[g.key] ? ' collapsed' : '') + '"><div class="tc-size-buttons">';
    vals.forEach(function (v) {
      var hide = !v.checked && !ui.showAll[g.key] && !top[v.norm];
      if (hide) hiddenCount++;
      html += '<label class="tc-size-btn' + (v.checked ? ' active' : '') + (hide ? ' tc-filter-item-hidden' : '') + '" title="' + v.count + ' ürün">' +
        '<input type="checkbox" data-group="' + g.key + '" value="' + esc(v.raw) + '"' + (v.checked ? ' checked' : '') + '>' +
        '<span>' + esc(v.raw) + '</span></label>';
    });
    html += '</div>';
    if (vals.length > CAP) {
      html += '<button type="button" class="tc-show-more-btn" data-action="show-more">' +
        (ui.showAll[g.key] ? 'Daha Az Göster' : 'Tümünü Göster <span class="tc-show-more-count">(' + hiddenCount + ' daha)</span>') +
        '</button>';
    }
    html += loadingHintHTML();
    html += '</div></div>';
    return html;
  }

  function colorGroupHTML(g, vals) {
    var html = '<div class="tc-filter-group' + (selCount(g.key) ? ' tc-has-active' : '') + '" data-group="' + g.key + '" data-filter-type="color">';
    html += groupHeaderHTML(g, selCount(g.key));
    html += '<div class="tc-filter-group-body' + (ui.collapsed[g.key] ? ' collapsed' : '') + '"><div class="tc-color-swatches">';
    vals.forEach(function (v) {
      var n = v.norm;
      var isMulti = n.indexOf('renkli') > -1 || n.indexOf('multi') > -1 || n.indexOf('desenli') > -1;
      var bg = COLOR_MAP[n] || v.raw;
      html += '<label class="tc-color-swatch' + (v.checked ? ' active' : '') + '" title="' + esc(v.raw) + ' (' + v.count + ')">' +
        '<input type="checkbox" data-group="' + g.key + '" value="' + esc(v.raw) + '"' + (v.checked ? ' checked' : '') + '>' +
        '<span class="tc-swatch-color' + (isMulti ? ' tc-swatch-multi' : '') + '" style="background-color:' + esc(bg) + '" data-color="' + esc(n) + '"></span>' +
        '<span class="tc-swatch-checkmark">✓</span></label>';
    });
    html += '</div>' + loadingHintHTML() + '</div></div>';
    return html;
  }

  function priceGroupHTML(g) {
    var rows = facets.price.filter(function (r) { return r.count > 0 || state.sel.price[r.id]; });
    if (!rows.length) return '';
    var html = '<div class="tc-filter-group' + (selCount('price') ? ' tc-has-active' : '') + '" data-group="price" data-filter-type="price">';
    html += groupHeaderHTML(g, selCount('price'));
    html += '<div class="tc-filter-group-body' + (ui.collapsed.price ? ' collapsed' : '') + '"><ul class="tc-filter-list">';
    rows.forEach(function (r) {
      var checked = !!state.sel.price[r.id];
      html += '<li><label class="tc-filter-label' + (checked ? ' tc-filter-active' : '') + '">' +
        '<div class="tc-checkbox-wrapper">' +
        '<input type="checkbox" class="tc-checkbox" data-group="price" value="' + r.id + '"' + (checked ? ' checked' : '') + '>' +
        '<span class="tc-custom-checkbox"></span></div>' +
        '<span class="tc-label-text">' + esc(r.label) + '</span>' +
        '<span class="tc-label-count">' + r.count + '</span>' +
        '</label></li>';
    });
    html += '</ul></div></div>';
    return html;
  }

  function renderFacets() {
    var html = '';
    GROUPS.forEach(function (g) {
      if (g.type === 'price') {
        html += priceGroupHTML(g);
        return;
      }
      var vals = sortedValues(g).filter(function (v) { return v.count > 0 || v.checked; });
      if (!vals.length) return; // boş grup gizli
      if (g.type === 'size') html += sizeGroupHTML(g, vals);
      else if (g.type === 'color') html += colorGroupHTML(g, vals);
      else html += listGroupHTML(g, vals);
    });
    // innerHTML yenilenince kaydırma konumu sıfırlanır — tıklanan grup görünümden
    // kaybolup "filtre almadı" hissi vermesin diye konumu koru.
    var sideScroll = el.sidebarScroller ? el.sidebarScroller.scrollTop : 0;
    var drawerScroll = el.drawerScroller ? el.drawerScroller.scrollTop : 0;
    el.facetsSidebar.innerHTML = html;
    el.facetsDrawer.innerHTML = html;
    if (el.sidebarScroller) el.sidebarScroller.scrollTop = sideScroll;
    if (el.drawerScroller) el.drawerScroller.scrollTop = drawerScroll;
  }

  /* ---------------- aktif filtre etiketleri + rozetler ---------------- */

  var TAG_X = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

  function renderActiveTags() {
    var total = totalSelCount();
    var html = '';
    GROUPS.forEach(function (g) {
      for (var n in state.sel[g.key]) {
        var label = state.sel[g.key][n];
        if (g.type === 'price') {
          var r = rangeById(n);
          label = r ? r.label : label;
        }
        html += '<button type="button" class="tc-active-tag" data-remove data-group="' + g.key + '" data-value="' + esc(state.sel[g.key][n]) + '">' + esc(label) + TAG_X + '</button>';
      }
    });
    el.activeTags.innerHTML = html;
    el.activeTags.style.display = total ? 'flex' : 'none';
    el.clearSidebar.style.display = total ? '' : 'none';
    el.clearSidebar.textContent = total ? 'Temizle (' + total + ')' : 'Temizle';
    el.clearDrawer.style.display = total ? '' : 'none';
    [el.badgeMobile, el.badgeDrawer].forEach(function (b) {
      if (!b) return;
      b.textContent = total;
      b.style.display = total ? 'inline-flex' : 'none';
    });
  }

  /* ---------------- ürün kartı ---------------- */

  function cardHTML(p) {
    var onSale = p.compareAt > p.price;
    var pct = onSale ? Math.round((p.compareAt - p.price) * 100 / p.compareAt) : 0;
    var isNew = (Date.now() / 1000 - p.createdAt) < NEW_SECONDS;
    var title = esc(p.title);

    var imgs;
    if (p.image) {
      imgs = '<img class="tc-product-image" src="' + esc(p.image) + '" alt="' + title + '" loading="lazy">';
      if (p.image2) {
        imgs += '<img class="tc-product-image tc-product-image-hover" src="' + esc(p.image2) + '" alt="' + title + '" loading="lazy">';
      }
    } else {
      imgs = '<div class="tc-product-no-image"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
    }

    var badges = '';
    if (isNew) badges += '<span class="tc-badge tc-badge-new">YENİ</span>';
    if (onSale) badges += '<span class="tc-badge tc-badge-sale">-%' + pct + '</span>';

    var priceRow = onSale
      ? '<span class="tc-price-sale">' + money(p.price) + '</span><span class="tc-price-compare">' + money(p.compareAt) + '</span>'
      : '<span class="tc-price-regular">' + money(p.price) + '</span>';

    /* Kampanya rozetleri. p.promos, snippets/tc-product-json.liquid içinde
       tc-promo-match ile üretilmiş anahtar listesidir — burada EŞLEŞTİRME YAPILMAZ.
       TCPromo.render(), snippets/tc-promo-badges.liquid ile byte düzeyinde aynı
       HTML üretir; ilk (Liquid) render ile filtre sonrası (JS) render eşit kalır.
       Alan yoksa (eşleşme olmayan ürün) boş string döner, DOM'a hiçbir şey girmez. */
    var promos = (typeof TCPromo !== 'undefined' && p.promos)
      ? TCPromo.render(p.promos, 'kart', p.price)
      : '';

    return '<article class="tc-product-card" data-product-id="' + p.id + '"' +
      ' data-vendor="' + esc(p.vendor) + '"' +
      ' data-anakategori="' + esc(toArr(p.anakategori).join('|')) + '"' +
      ' data-cinsiyet="' + esc(toArr(p.cinsiyet).join('|')) + '"' +
      ' data-category="' + esc(toArr(p.kategori).join('|')) + '">' +

      '<button class="tc-btn-wishlist" type="button" aria-label="Favorilere ekle" data-product-id="' + p.id + '"' +
      ' onclick="event.stopPropagation(); typeof TCCart !== \'undefined\' && TCCart.toggleWishlist(this, \'' + p.id + '\')">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '</button>' +

      '<a href="' + esc(p.url) + '" class="tc-product-card-link">' +
      '<div class="tc-product-image-wrapper">' +
      '<div class="tc-card-actions">' +
      '<button class="tc-btn-addtocart" type="button" aria-label="Hızlı görünüm — sepete ekle" data-product-handle="' + esc(p.handle) + '"' +
      ' onclick="event.stopPropagation(); if (typeof TCCart !== \'undefined\' && TCCart.openQuickAdd) { event.preventDefault(); TCCart.openQuickAdd(\'' + esc(p.handle) + '\'); }">' +
      '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
      ' <span class="tc-btn-addtocart-label">Sepete Ekle</span></button>' +
      '</div>' +
      imgs +
      '<div class="tc-product-badges">' + badges + '</div>' +
      '</div>' +
      '<div class="tc-product-info">' +
      (p.vendor ? '<span class="tc-product-brand">' + esc(p.vendor) + '</span>' : '') +
      '<h3 class="tc-product-title">' + title + '</h3>' +
      '<div class="tc-product-price-row">' + priceRow + '</div>' +
      promos +
      '</div></a></article>';
  }

  /* ---------------- grid + sonsuz kaydırma ---------------- */

  function updateSentinel() {
    var more = renderedCount < visible.length;
    el.loader.style.display = more ? 'flex' : 'none';
  }

  /* Boş durum mesajı — filtre YOKSA kullanıcıyı suçlamayan metin.
     Koleksiyon sayfası yalnız satın alınabilir ürünü basıyor (tc-collection.liquid
     `product.available` koşulu), o yüzden hiç filtre uygulanmadan boş kalan bir
     koleksiyon "filtreyle bulunamadı" değil, "şu an alınabilir ürün yok" demek.
     Örnek: /collections/erkek-boxer — 3 ürünü var, üçü de tükenmiş; kullanıcı
     aramadan gelip hiç filtre uygulamadan "Bu filtrelerle ürün bulunamadı"
     görüyordu. Filtre varsa eski metin ve "Filtreleri Temizle" düğmesi kalıyor. */
  function setEmptyMessage() {
    var msg = document.getElementById('tc-no-results-msg');
    var clear = document.getElementById('tc-no-results-clear');
    var filtreliMi = totalSelCount() > 0;
    if (msg) {
      msg.textContent = filtreliMi
        ? 'Bu filtrelerle ürün bulunamadı.'
        : 'Bu koleksiyonda şu an satın alınabilir ürün yok.';
    }
    if (clear) clear.style.display = filtreliMi ? '' : 'none';
  }

  function renderGrid(keepCount) {
    visible = sortProducts(ALL.filter(function (p) { return matches(p, null); }));
    var target = keepCount ? Math.max(renderedCount, CHUNK) : CHUNK;
    target = Math.min(target, visible.length);
    el.grid.innerHTML = visible.slice(0, target).map(cardHTML).join('');
    renderedCount = target;
    var empty = visible.length === 0;
    el.grid.style.display = empty ? 'none' : '';
    el.noResults.style.display = empty ? 'flex' : 'none';
    if (empty) setEmptyMessage();
    updateSentinel();
    updateStatsBadge();
  }

  /* Gizli sayaç rozeti (Alt+T) — yalnız mağaza sahibi için, ziyaretçi görmez */
  function updateStatsBadge() {
    var b = document.getElementById('tc-stats-badge');
    if (!b) return;
    b.textContent = 'Görünen: ' + visible.length +
      ' · Stokta: ' + ALL.length +
      ' · Koleksiyon toplam: ' + (meta ? meta.total : '?');
  }

  function appendChunk() {
    if (renderedCount >= visible.length) return;
    var next = visible.slice(renderedCount, renderedCount + CHUNK);
    el.grid.insertAdjacentHTML('beforeend', next.map(cardHTML).join(''));
    renderedCount += next.length;
    updateSentinel();
  }

  /* ---------------- URL senkronu ---------------- */

  function writeURL(push) {
    var sp = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) { sp.delete(g.param); });
    // Eski tip native "filter.*" paramları da temizle — sunucu tarafı
    // ön-filtrelemeyi tetikleyip veri setini bozmasınlar.
    var stale = [];
    sp.forEach(function (val, name) { if (name.indexOf('filter.') === 0) stale.push(name); });
    stale.forEach(function (name) { sp.delete(name); });
    sp.delete('sort_by');
    sp.delete('page');
    GROUPS.forEach(function (g) {
      var m = state.sel[g.key];
      Object.keys(m).sort().forEach(function (n) { sp.append(g.param, m[n]); });
    });
    if (state.sort && state.sort !== 'manual') sp.set('sort_by', state.sort);
    var qs = sp.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    try {
      if (push) window.history.pushState({ tc: 1 }, '', url);
      else window.history.replaceState({ tc: 1 }, '', url);
    } catch (e) { /* history yoksa sessiz geç */ }
  }

  /* Gruptaki bilinen tüm değerlerin norm seti (virgül-bölme doğrulaması için) */
  function knownNorms(g) {
    var set = {};
    ALL.forEach(function (p) {
      if (g.variant) {
        p.variants.forEach(function (v) { g.vget(v).forEach(function (val) { set[norm(val)] = 1; }); });
      } else {
        g.get(p).forEach(function (val) { set[norm(val)] = 1; });
      }
    });
    return set;
  }

  function readURL() {
    var sp = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      state.sel[g.key] = {};
      var raws = sp.getAll(g.param);
      if (!raws.length) return;
      if (g.type === 'price') {
        raws.forEach(function (raw) {
          String(raw).split(',').forEach(function (tok) {
            tok = tok.trim();
            if (rangeById(tok)) state.sel.price[tok] = tok;
          });
        });
        return;
      }
      // "L,XL" gibi virgüllü çoklu değer desteklenir. "42,5" gibi virgül içeren
      // GERÇEK bir değer, bilinen değer setinde varsa bölünmez.
      var known = knownNorms(g);
      raws.forEach(function (raw) {
        raw = String(raw).trim();
        if (g.key === 'beden') raw = cleanSize(raw); // "44,5" → "44.5" (virgül-bölmeye takılmasın)
        if (raw === '') return;
        if (raw.indexOf(',') > -1 && !known[norm(raw)]) {
          raw.split(',').forEach(function (tok) {
            tok = tok.trim();
            if (tok !== '') state.sel[g.key][norm(tok)] = tok;
          });
        } else {
          state.sel[g.key][norm(raw)] = raw;
        }
      });
    });
    var s = sp.get('sort_by');
    state.sort = s || 'manual';
  }

  function syncSortSelects() {
    [el.sortDesktop, el.sortMobile].forEach(function (sel) {
      if (sel) sel.value = state.sort;
    });
  }

  /* ---------------- ana akış ---------------- */

  function refresh(push, keepCount) {
    computeFacets();
    renderFacets();
    renderActiveTags();
    renderGrid(keepCount);
    if (push) writeURL(true);
  }

  function toggleValue(key, raw, on) {
    var g = null;
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].key === key) { g = GROUPS[i]; break; }
    if (!g) return;
    var n = g.type === 'price' ? raw : norm(raw);
    if (on) state.sel[key][n] = String(raw).trim();
    else delete state.sel[key][n];
    refresh(true, false);
  }

  /* Grup içi arama — yeniden render etmeden DOM'da gizle/göster (focus kaybolmasın) */
  function applySearchDOM(container, key) {
    var group = container.querySelector('.tc-filter-group[data-group="' + key + '"]');
    if (!group) return;
    var q = norm(ui.search[key] || '');
    var lis = group.querySelectorAll('.tc-filter-list li');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var txtEl = li.querySelector('.tc-label-text');
      var txt = txtEl ? norm(txtEl.textContent) : '';
      var show = !q || txt.indexOf(q) > -1;
      li.classList.toggle('tc-filter-item-hidden', !show);
    }
    var moreBtn = group.querySelector('.tc-show-more-btn');
    if (moreBtn) moreBtn.style.display = q ? 'none' : '';
  }

  function syncCollapse(key) {
    [el.facetsSidebar, el.facetsDrawer].forEach(function (c) {
      var group = c.querySelector('.tc-filter-group[data-group="' + key + '"]');
      if (!group) return;
      var header = group.querySelector('.tc-filter-group-header');
      var body = group.querySelector('.tc-filter-group-body');
      if (header) header.setAttribute('aria-expanded', ui.collapsed[key] ? 'false' : 'true');
      if (body) body.classList.toggle('collapsed', !!ui.collapsed[key]);
    });
  }

  function wireFacetContainer(container) {
    container.addEventListener('change', function (e) {
      var input = e.target.closest ? e.target.closest('input[data-group]') : null;
      if (!input) return;
      toggleValue(input.getAttribute('data-group'), input.value, input.checked);
    });
    container.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-action]') : null;
      if (!t) return;
      var groupEl = t.closest('.tc-filter-group');
      if (!groupEl) return;
      var key = groupEl.getAttribute('data-group');
      var action = t.getAttribute('data-action');
      if (action === 'toggle-group') {
        ui.collapsed[key] = !ui.collapsed[key];
        syncCollapse(key);
      } else if (action === 'show-more') {
        ui.showAll[key] = !ui.showAll[key];
        renderFacets();
      }
    });
    container.addEventListener('input', function (e) {
      var inp = e.target.closest ? e.target.closest('input[data-search]') : null;
      if (!inp) return;
      var key = inp.getAttribute('data-search');
      ui.search[key] = inp.value;
      applySearchDOM(container, key);
    });
  }

  /* ---------------- arka plan sayfa yükleme (>250 ürün) ---------------- */

  function mergeProducts(list, pageNum) {
    var offset = (pageNum - 1) * (meta.pageSize || 250);
    (list || []).forEach(function (p, i) {
      if (!p || seenIds[p.id]) return;
      seenIds[p.id] = true;
      if (p.available === false) return; // stokta olmayan ürün HER YERDE gizli
      p.idx = offset + i;
      p.price = Number(p.price) || 0;
      p.compareAt = Number(p.compareAt) || 0;
      p.createdAt = Number(p.createdAt) || 0;
      if (!Array.isArray(p.variants)) p.variants = [];
      // Boyut optimizasyonu: JSON'a yalnız stoktaki varyantlar yazılır ve
      // "available" alanı atlanır — eksikse true varsay.
      p.variants.forEach(function (v) { if (v && v.available === undefined) v.available = true; });
      ALL.push(p);
    });
  }

  function fetchPage(n) {
    var sp = new URLSearchParams();
    sp.set('section_id', 'tc-products-json');
    sp.set('page', n);
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) sp.set('preview_theme_id', preview);
    var base = meta.url || window.location.pathname;
    return fetch(base + '?' + sp.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('script[data-tc-products]');
        if (!s) throw new Error('veri script bulunamadı');
        return JSON.parse(s.textContent);
      });
  }

  /* Bir sayfayı en fazla 3 kez dene (artan bekleme ile) — Shopify aralıklı 503
     döndürebiliyor; geçici hata veri setini KALICI eksik bırakmasın. */
  function fetchPageWithRetry(n, attempt) {
    attempt = attempt || 1;
    return fetchPage(n).catch(function (err) {
      if (attempt >= 3) throw err;
      return new Promise(function (res) { setTimeout(res, 700 * attempt); })
        .then(function () { return fetchPageWithRetry(n, attempt + 1); });
    });
  }

  function loadRemainingPages() {
    if (!meta.pages || meta.pages <= 1) return;
    var queue = [];
    for (var n = 1; n <= meta.pages; n++) if (n !== meta.page) queue.push(n);
    if (!queue.length) return;
    pagesLoading = true;
    el.progress.style.display = 'flex';

    var rounds = 0;

    function runQueue(pages) {
      var failed = [];
      var idx = 0, active = 0;

      function finish() {
        if (failed.length && rounds < 12) {
          // Kalıcı eksik veri bırakma: Shopify aralıklı 503 döndürebiliyor —
          // başarısız sayfaları artan beklemeyle ısrarla yeniden dene.
          rounds++;
          var delay = Math.min(4000 + rounds * 2000, 15000);
          var again = failed.slice();
          setTimeout(function () { runQueue(again); }, delay);
          return;
        }
        pagesLoading = false;
        el.progress.style.display = 'none';
        if (failed.length && window.console && console.warn) {
          console.warn('[TCCollection] yüklenemeyen sayfalar:', failed.join(','));
        }
        refresh(false, true);
      }

      function pump() {
        if (idx >= pages.length) {
          if (active === 0) finish();
          return;
        }
        while (active < 2 && idx < pages.length) { // 2 paralel istek — eksik-veri penceresini kısaltır
          (function (page) {
            active++;
            fetchPageWithRetry(page)
              .then(function (data) {
                mergeProducts(data.products, data.page || page);
                refresh(false, true); // her parça geldikçe grid + facet sayıları tazelenir
              })
              .catch(function (err) {
                failed.push(page);
                if (window.console && console.warn) console.warn('[TCCollection] sayfa ' + page + ' yüklenemedi:', err);
              })
              .then(function () {
                active--;
                pump();
              });
          })(pages[idx++]);
        }
      }
      pump();
    }

    runQueue(queue);
  }

  /* ---------------- public API ---------------- */

  var API = {
    openDrawer: function () {
      var d = document.getElementById('tc-filter-drawer');
      var o = document.getElementById('tc-drawer-overlay');
      var b = document.getElementById('tc-filter-toggle');
      if (d) d.classList.add('open');
      if (o) o.classList.add('active');
      if (b) b.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    },
    closeDrawer: function () {
      var d = document.getElementById('tc-filter-drawer');
      var o = document.getElementById('tc-drawer-overlay');
      var b = document.getElementById('tc-filter-toggle');
      if (d) d.classList.remove('open');
      if (o) o.classList.remove('active');
      if (b) b.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    },
    clearAll: function () {
      GROUPS.forEach(function (g) { state.sel[g.key] = {}; });
      ui.search = {};
      refresh(true, false);
    },
    updateSort: function (v) {
      state.sort = v || 'manual';
      syncSortSelects();
      writeURL(true);
      renderGrid(false);
    },
    /* Gizli sayaç: Alt+T ile aç/kapa, ya da konsoldan TCCollection.toggleStats() */
    toggleStats: function () {
      var b = document.getElementById('tc-stats-badge');
      if (b) { b.parentNode.removeChild(b); return; }
      b = document.createElement('div');
      b.id = 'tc-stats-badge';
      document.body.appendChild(b);
      updateStatsBadge();
    },
    /* Konsol için: TCCollection.stats() */
    stats: function () {
      return {
        koleksiyonToplam: meta ? meta.total : 0, // stoksuz dahil tüm ürünler
        stokta: ALL.length,                      // veri setindeki (stokta) ürün
        filtreyleGorunen: visible.length,        // aktif filtrelerle görünen
        griddeYuklu: renderedCount               // sonsuz kaydırmayla şu an basılı kart
      };
    }
  };
  window.TCCollection = API;

  /* ---------------- init ---------------- */

  function init() {
    var dataEl = document.getElementById('tc-products-data');
    if (!dataEl) return;

    var payload;
    try {
      payload = JSON.parse(dataEl.textContent);
    } catch (e) {
      if (window.console && console.error) console.error('[TCCollection] veri seti parse edilemedi:', e);
      return;
    }

    meta = {
      url: payload.url || window.location.pathname,
      page: payload.page || 1,
      pages: payload.pages || 1,
      pageSize: payload.pageSize || 250,
      total: payload.total || 0
    };

    el.grid = document.getElementById('tc-product-grid');
    el.noResults = document.getElementById('tc-no-results');
    el.loader = document.getElementById('tc-infinite-loader');
    el.sentinel = document.getElementById('tc-infinite-sentinel');
    el.progress = document.getElementById('tc-data-progress');
    el.facetsSidebar = document.getElementById('tc-facets-sidebar');
    el.facetsDrawer = document.getElementById('tc-facets-drawer');
    el.sidebarScroller = document.getElementById('tc-filter-sidebar');
    el.drawerScroller = document.querySelector('#tc-filter-drawer .tc-drawer-body');
    el.activeTags = document.getElementById('tc-active-tags');
    el.clearSidebar = document.getElementById('tc-clear-sidebar');
    el.clearDrawer = document.getElementById('tc-clear-drawer');
    el.badgeMobile = document.getElementById('tc-badge-mobile');
    el.badgeDrawer = document.getElementById('tc-badge-drawer');
    el.sortDesktop = document.getElementById('tc-sort-desktop');
    el.sortMobile = document.getElementById('tc-sort-mobile');
    if (!el.grid || !el.facetsSidebar) return;

    mergeProducts(payload.products, meta.page);

    readURL();
    syncSortSelects();

    wireFacetContainer(el.facetsSidebar);
    wireFacetContainer(el.facetsDrawer);

    el.activeTags.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-remove]') : null;
      if (!t) return;
      toggleValue(t.getAttribute('data-group'), t.getAttribute('data-value'), false);
    });

    if ('IntersectionObserver' in window && el.sentinel) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) appendChunk();
        });
      }, { rootMargin: '600px 0px' });
      io.observe(el.sentinel);
    }
    // IO'ya ek güvence: gizli sekme / eski tarayıcıda da kaydırma parça ekler.
    // Sentinel viewport'un üstünde kaldıysa (hızlı kaydırmayla geçildiyse) de ekle.
    if (el.sentinel) {
      window.addEventListener('scroll', function () {
        var rect = el.sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) appendChunk();
      }, { passive: true });
    }

    window.addEventListener('popstate', function () {
      readURL();
      syncSortSelects();
      refresh(false, false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') API.closeDrawer();
      // Gizli sayaç kısayolu: Alt+T (form alanlarında yazarken devreye girmez)
      if (e.altKey && (e.key === 't' || e.key === 'T')) {
        var tag = (e.target && e.target.tagName) || '';
        if (tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT') API.toggleStats();
      }
    });

    refresh(false, false);
    loadRemainingPages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();